import React from "react";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "../../../Services/axiosCommon";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../Components/Utils/Buttons";
import Attachement from "./Attachement";
import * as yup from "yup";
import { notification } from "antd";
import useFetchMataData from "../../../Components/Hooks/useFetchMataData";
import ViewFiles from "./viewFiles";
import Breadcrumb from "../../../Components/Utils/Breadcrumb";
import Dashboard from "../Dashboard";
import { NuDate, NuInput, NuTextArea, NuTime } from "../../../Components/Utils/Input";
import FormikSelectTwo from "../../../Components/Utils/Select";

const filetype = ["docx", "doc", "xlsx", "xls", "pdf", "txt", "pptx","mp4", "mov", "wmv", "avi", "flv", "mkv"];


export default function NoteEdit() {
  // let { value } = useFetchMataData("/Metadata/noteStatus");
  const { value: noteStatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "noteStatus"
  );
  const location = useLocation();
  const {officeId}=useParams();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const data = location.state?.data;
  const AttachementArr = data?.attachments ? data?.attachments: [];
  const navigate = useNavigate();
  const [image, setImage] = useState([]);
  const [status, setStatus] = useState([]);
  const [createNew, setCreateNew] = useState({
    title: "",
    description: "",
    status: "",
    reminder_date: "",
    reminder_time: "",
    due_date: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePathList, setFilePathList] = useState([]);
  const [removefilePathList, setRemoveFilePathList] = useState([]);
  const handleChangeImg = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };

  // const getStatus = () => {
  //   axios
  //     .get(`/Metadata/noteStatus`)
  //     .then((res) => {
  //       let data = res.data?.data?.keyValues;
  //       let tempData = [];
  //       data.forEach((item) => {
  //         let tempObject = { value: item, label: item };
  //         tempData.push(tempObject);
  //       });
  //       res.data?.data?.keyValues && setStatus(tempData);
  //     })
  //     .catch((error) => {
  //       console.log("error", error);
  //     });
  // };

  // useEffect(() => {
  //   getStatus();
  // }, []);

  useEffect(() => {
    data &&
      setCreateNew({
        title: data?.title,
        description: data?.description,
        status: data?.status,
        reminder_date: data?.reminder_date,
        reminder_time: data?.reminder_time,
        due_date: data?.due_date,
      });

    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      setFilePathList(data?.attachments);
      setRemoveFilePathList(data?.attachments);
    }
  }, [data]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: true,
    validationSchema: yup.object({
      title: yup.string().required("Title is Required"),
      status: yup.string().required("Please Select Status"),
    }),
    onSubmit: async (value) => {
      setIsLoading(true);
      let formData = new FormData();
      if (value.reminder_time == "00:00:00") {
        value.reminder_time = "";
      }
      if (removefilePathList) {
        let tempArr = [];
        let finalArr = removefilePathList.filter(
          (items) => !filePathList.includes(items)
        );
        finalArr && finalArr.map(fileName=>{
          tempArr.push(fileName.file)
        })
        value.files_to_remove = tempArr;
      } else {
        value.files_to_remove = [];
      }
      formData.append("my_notes", JSON.stringify(value));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }

      data
        ? axios
            .put(`/Notes/${data?.notesId}`, formData)
            .then((res) => {
              if (res.status == 201 || res.data.status == true) {
                setIsLoading(false);
                setImage([]);
                api.success({
                  message: `Add successfully`,
                  description: res?.data?.msg || " Updated",
                  placement: "bottomRight",
                });
                navigate(-1);
              } else {
                setIsLoading(false);
                api.error({
                  message: `Unsuccessfully`,
                  description: res?.data?.msg || "Updated failed",
                  placement: "bottomRight",
                });
              }
            })
            .catch((err) => {
              setIsLoading(false);
              api.error({
                message: `Unsuccessfully`,
                description: err?.response?.data?.msg || "Updated failed",
                placement: "bottomRight",
              });
            })
        : axios
            .post("/Notes/", formData)
            .then((res) => {
              if (res.status == 201 || res.data.status == true) {
                setIsLoading(false);
                setImage([]);
                api.success({
                  message: `Add successfully`,
                  description: res?.data?.msg || " Updated",
                  placement: "bottomRight",
                });
                navigate(-1);
              } else {
                setIsLoading(false);
                api.error({
                  message: `Unsuccessfully`,
                  description: res?.data?.msg || "Updated failed",
                  placement: "bottomRight",
                });
              }
            })
            .catch((err) => {
              setIsLoading(false);
              api.error({
                message: `Unsuccessfully`,
                description: err?.response?.data?.msg || "Updated failed",
                placement: "bottomRight",
              });
            });
    },
  });

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = []
    files.map(item=>{
      if (item.size < maxFileSize ){
        fileArr.push(item)
      }else{
        api.warning({
          message: `File Size to big`,
          description: `${item.name} is Removed and not Uploaded`,
          placement: "bottomRight",
        });
      }
    })    
    let tempArr = []
    setSelectedFile(fileArr);
    files.map(item=>{
      if (item.size < maxFileSize ){
      let fileName = item?.name
      let fileExtention =  fileName.split(".").reverse()[0]
      if(filetype?.includes(fileExtention)){
        tempArr.push(fileName)
      }else{
        let x = URL.createObjectURL(item)
        tempArr.push(x)
      }
    }
    })
    setImage(tempArr)
  }

  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList.file !== item);
    setFilePathList(filterList);
  }
  return (
    <div className="w-full mx-auto py-2 px-4 ">
      {contextHolder}
      <div className="md:flex justify-between w-full">
        <Breadcrumb
          items={[
           
            {
              name: "My Diary", link:`/dairy/`
            },
            { name: "Edit" },
          ]}
        />

        <div className=" flex gap-2 items-center mr-6">
          <BackButton />
        </div>
      </div>
      <div>
      <div
          className=" w-full mx-auto h-[calc(100vh-145px)] rounded-[6px] mt-2 overflow-y-scroll bg-white"
          // style={{ border: "1px solid #C5C5C5" }}
        >      <form onSubmit={formik.handleSubmit}>
            <div className="w-full">
                <p className="py-2 px-4 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                  My Diary :
                </p>
              </div>
            <div className="flex flex-wrap justify-between">
              <NuInput
               type="text"
                label="Title"
                isRequired={true}
                placeholder="Title"
                formik={formik}
                name="title"
                width="w-full md:w-1/2"
              />
              {/* <FormikSelectTwo
                label="Status"
                Options={noteStatus}
                formik={formik}
                placeholder="Choose"
                name="status"
                width="w-full md:w-1/4"
                isRequired={true}
              /> */}
               <FormikSelectTwo
                  label="Status"
                  Options={noteStatus}
                  formik={formik}
                  placeholder="Choose"
                  name="status"
                  width="w-full md:w-1/4"
                  isRequired={true}
                />
               <NuDate
                label="Due date"
                formik={formik}
                name="due_date"
                width=" w-full md:w-1/4"
              />

              <NuTextArea
                label="Description"
                placeholder="Title"
                formik={formik}
                name="description"
                width="w-full md:w-1/2"
              />

<NuDate
                label="Reminder date"
                formik={formik}
                name="reminder_date"
                width=" w-full md:w-1/4"
              />
              <NuTime
                disabled={formik.values.reminder_date ? false : true}
                label="Reminder Time "
                de
                formik={formik}
                name="reminder_time"
                width=" w-full md:w-1/4"
                min={new Date()}
              />

              <div className=" w-1/2 flex gap-2 items-center ">
                {AttachementArr &&
                  filePathList.map((imgs, idx) => {
                    return (
                      <div
                        className=" w-28 h-11 relative flex justify-center items-center rounded-lg m-2"
                        key={idx}
                        style={{ border: "1px solid gray" }}
                      >
                        <div
                          className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                          onClick={() => UpdateAttachmentList(imgs.file)}
                        >
                          x
                        </div>
                        <div className=" w-28 h-11 flex justify-center items-center rounded-lg overflow-hidden">
                        <ViewFiles data={imgs} key={idx} />
                        </div>
                      </div>
                    );
                  })}

                <Attachement
                  handleChange={handleImageChange}
                  preview={image || data?.image || ""}
                  width="w-full"
                  label="Attach"
                  multiple={true}
                />
              </div>
            </div>

            <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-4 mt-6 md:mr-4">
              <CancelButton handleClick={() => navigate(-1)} />
              <SubmitButton isLoading={isLoading} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
